<div class="select-all">
  <button mat-icon-button (click)="selectAllToggle()">
    <mat-icon>done_all</mat-icon>
    <span>Select All/None</span>
  </button>
</div>
